export default theme => ({
  noticeDscr: {
    ...theme.confirmPopup.text,
  },
});
